module.exports = __webpack_public_path__ + "static/media/expand.c13b5923.svg";